<template>
    <a
        :href="link"
        class="category"
    >
        <span class="category__icon" v-html="icon"></span>
        <span class="category__text">{{ category.title }}</span>
    </a>
</template>

<script>
    import icons from '@/configs/icons.js';

    export default {
        name: 'CategoriesListButton',
        props: ['category'],
        computed: {
            link () {
                return '/category/' + this.category.alias;
            },
            icon () {
                return icons.category[this.category.alias];
            }
        }
    }
</script>

<style lang="scss" scoped>
    .category {
        display: flex;
        align-items: center;
        max-width: 320px;
        height: 48px;
        margin: 1em auto;
        text-decoration: none;

        &:hover {
            opacity: 0.7;
        }

        &__icon {
            width: 48px;
        }

        &__text {
            margin-left: 20px;
            font-size: 1.5em;
            text-decoration: none;
            color: #333;
        }
    }

    @media screen and (max-width: 600px) {
        .category {
            max-width: 100%;
        }
    }
</style>